import { QueryClientProvider } from '@tanstack/react-query';
import { useEffect, useRef, useState } from 'react';
import type { ReactNode } from 'react';

import { sessionKey } from '@/features/auth';
import { onUnauthorized } from '@/shared/api/httpClient';
import { createQueryClient } from '@/shared/api/queryClient';
import { watchSystemTheme } from '@/shared/theme/themeStore';
import { ToastProvider } from '@/shared/ui';

import { registerVocabulary } from './vocabulary';

/**
 * Korzeń kompozycji. Wszystko, co globalne, wisi tutaj i nigdzie indziej.
 */

/*
 * Słownictwo podstawiane do każdego tłumaczenia (patrz `vocabulary.ts`).
 *
 * ⚠ Wołane przy WCZYTANIU MODUŁU, nie w efekcie: interpolacja musi znać te wartości już
 * przy pierwszym renderze, a efekt biegnie po nim. Bez tego pierwsze malowanie pokazałoby
 * `{{role.admin}}` zamiast nazwy roli — i to tylko przez jedną klatkę, czyli w sposób
 * najtrudniejszy do zauważenia.
 */
registerVocabulary();

export function Providers({ children }: { children: ReactNode }) {
  // Klient zapytań w stanie, nie w module: dwa równoległe testy w jednym procesie
  // dostają wtedy własne pamięci podręczne, zamiast dziedziczyć po sobie dane.
  const [queryClient] = useState(createQueryClient);
  const clientRef = useRef(queryClient);

  useEffect(() => watchSystemTheme(), []);

  useEffect(() => {
    // Utrata sesji w dowolnym miejscu aplikacji zeruje „kim jestem", a wtedy
    // `RequireAuth` przekierowuje na logowanie i zapamiętuje adres powrotu.
    // Przekierowanie NIE dzieje się tutaj celowo: `shared/api` nie zna routera,
    // a router nie musi wiedzieć, że istnieje warstwa HTTP.
    return onUnauthorized(() => {
      clientRef.current.setQueryData(sessionKey, null);
    });
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <ToastProvider>{children}</ToastProvider>
    </QueryClientProvider>
  );
}
